import { FeaturedPageOut, ProductGroupOut } from '../../../store/api';

export const mapProductGroup = (
    featuredPages?: FeaturedPageOut[],
    productGroupId?: number
): ProductGroupOut | undefined => {
    return featuredPages
        ?.find(({ productGroupSlots }) =>
            productGroupSlots?.find(({ productGroup }) => productGroup?.id === productGroupId)
        )
        ?.productGroupSlots?.find(({ productGroup }) => productGroup?.id === productGroupId)?.productGroup;
};
